import React, { Component } from "react";
import UserService from "../services/user.service";
import AuthService from "../services/auth.service";

import Map from './maps';
import './leaflet.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { faCheckSquare, faDoorClosed, faDoorOpen, faBoxes, faWarehouse, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Card, Row, Col } from 'react-bootstrap';
import { Link, Navigate } from "react-router-dom";
import logo from '../banner-nuban.jpg';
import logo1 from '../banner-expanmetal.jpg';

library.add(fab, faCheckSquare, faDoorClosed, faDoorOpen, faBoxes, faWarehouse, faArrowRight);

export default class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            content: "",
            redirectToLogin: false
        };
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {

        const user = AuthService.getCurrentUser();
        if (user) {
            this.setState({
                currentUser: user,
                showModeratorBoard: user.roles.includes("ROLE_MODERATOR"),
                showAdminBoard: user.roles.includes("ROLE_ADMIN"),
                showUser: user.roles.includes("ROLE_USER")
            });
        } else {
            console.log('salgo');
            AuthService.logout();
            this.setState({ redirectToLogin: true });
            //this.props.history.push('/tuhorario/login');
        }

        if ("geolocation" in navigator) {
            console.log("Available");
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    console.log("Latitude is :", position.coords.latitude);
                    console.log("Longitude is :", position.coords.longitude);
                },
                function (error) {
                    console.error("Error Code = " + error.code + " - " + error.message);
                }
            );
        } else {
            console.log("Not Available");
        }

        UserService.getAdminBoard().then(
            response => {
                console.log(response);
                this.setState({
                    content: response.data
                });
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });
            }
        );


    }

    handleClick(e) {
        e.preventDefault();

        UserService.setEntrar().then(
            response => {
                console.log(response);
                this.setState({
                    content: response.data
                });
            },
            error => {
                this.setState({
                    content:
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString()
                });
            }
        );

    }

    render() {

        const { currentUser, showModeratorBoard, showAdminBoard, showUser } = this.state;

        if (this.state.redirectToLogin) {
            return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />
        }


        return (
            <div className="container-fluid py-4">
                {showUser && (
                  <>
                    <h4 className="fw-semibold mb-3">Stock</h4>
                    <Row className="g-4">
                      <Col md={6}>
                        <Card as={Link} to={`${process.env.PUBLIC_URL}/solicitudes`} className="stock-card h-100 shadow-sm border-0 text-reset text-decoration-none">
                          <Card.Img variant="top" src={logo} alt="Nuban" className="stock-card-img" style={{ objectFit: 'cover', maxHeight: 220 }} />
                          <Card.Body>
                            <Card.Title className="mb-1 d-flex align-items-center gap-2">
                              <FontAwesomeIcon icon={faBoxes} className="text-primary" />
                              Nuban
                            </Card.Title>
                            <div className="d-flex justify-content-between align-items-center">
                              <Card.Text className="text-muted mb-0">Ver stock y disponibilidad</Card.Text>
                              <FontAwesomeIcon icon={faArrowRight} className="text-muted" />
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col md={6}>
                        <Card as={Link} to={`${process.env.PUBLIC_URL}/expanmetal`} className="stock-card h-100 shadow-sm border-0 text-reset text-decoration-none">
                          <Card.Img variant="top" src={logo1} alt="Expanmetal" className="stock-card-img" style={{ objectFit: 'cover', maxHeight: 220 }} />
                          <Card.Body>
                            <Card.Title className="mb-1 d-flex align-items-center gap-2">
                              <FontAwesomeIcon icon={faWarehouse} className="text-primary" />
                              Expanmetal
                            </Card.Title>
                            <div className="d-flex justify-content-between align-items-center">
                              <Card.Text className="text-muted mb-0">Ver stock y disponibilidad</Card.Text>
                              <FontAwesomeIcon icon={faArrowRight} className="text-muted" />
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </>
                )}
            </div>
        );
    }
}






